import React, { FC, useCallback, useMemo } from 'react';
import { GenericTable } from '@publicisgroupe/p-os-components';
import { Entity } from '../../interfaces/Entity';
import { XdmItemWithAmount } from '../XdmItemWithAmount/XdmItemWithAmount';
import { getEntityPropertyName } from '../../utils/xdmUtils';
import { Field } from '../../interfaces/Field';

import './XdmContextTableData.less';

type Props<TData> = {
  data: TData[];
  mappings?: Field;
};

export const XdmContextTableData: FC<Props<Entity>> = ({ data, mappings }) => {
  const getMappings = useCallback(
    (entityName: string) => {
      const field = mappings?.xdmContext?.fields?.find(
        (el: Field) => el.name === entityName
      );

      return field?.xdm?.mappings ?? {};
    },
    [mappings]
  );

  const renderItem = useCallback(
    (item: any, columnName: string) =>
      Array.isArray(item[columnName]) ? (
        <XdmItemWithAmount
          items={item[columnName]}
          mappings={getMappings(columnName)}
        />
      ) : (
        <span>
          {
            item[columnName][
              getEntityPropertyName(getMappings(columnName), 'name') ?? ''
            ]
          }
        </span>
      ),
    [getMappings]
  );
  const columns = useMemo<any>(() => {
    const columnList = Object.keys(data[0]).filter((el) => el !== 'id');
    const getName = (name: string) => {
      const words = name.split(/(?=[A-Z])/);
      return words
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    };

    return columnList.map((column) => {
      return {
        name: getName(column),
        selector: column,
        cell: (item: Entity) => renderItem(item, column),
      };
    });
  }, [data, renderItem]);

  return (
    <>
      <h6 className="xdm-title">XDM Context Row</h6>
      <GenericTable
        getId={(x: any) => `${x.id}`}
        columnDefinitions={columns ?? []}
        className="p-os-grid"
        data={data ?? []}
        onSort={() => null}
        hidePagination={true}
        pageCount={0}
        pageIndex={0}
        onPageChange={() => null}
      />
    </>
  );
};
